import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const userMgmtProfileApi = createAggrApiInstance(aggr.UserMgmtProfileApi)

/** 重新寄送認證 Email */
export const sendConfirmEmail = async (reqData: aggr.UserResendConfirmEmailRq) => {
  const res = await handleApiStatus(() => userMgmtProfileApi.profileResendconfirmemail(reqData))
  return res
}

/** 取得使用者摘要 */
export const querySummary = async () => {
  const res = await handleApiStatus(() => userMgmtProfileApi.profileQuerysummary())
  return res
}

/** 取消邀請 */
export const cancelInvitation = async (reqData: aggr.UserCancelInvitationRq) => {
  const res = await handleApiStatus(() => userMgmtProfileApi.profileCancelinvitation(reqData))
  return res
}
